"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _FilterAndSortBar = _interopRequireDefault(require("../FilteredList/FilterAndSortBar"));
var _styles = require("@material-ui/core/styles");
var _PaginationWebinar = _interopRequireDefault(require("../PaginationWebinar"));
var _history3 = require("history");
var _navigation = require("next/navigation");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isBrowser = typeof window !== 'undefined';
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    list: {
      '& li:nth-of-type(1)': (0, _defineProperty2.default)({
        paddingTop: theme.spacing(6)
      }, theme.breakpoints.up('md'), {
        paddingTop: theme.spacing(0)
      })
    }
  };
});
var ItemListPanel = function ItemListPanel(props) {
  var _props$items = props.items,
    items = _props$items === void 0 ? [] : _props$items,
    id = props.id,
    wrapperClass = props.wrapperClass,
    emptyResultDefault = props.emptyResultDefault,
    renderContent = props.renderContent,
    selectedFacets = props.selectedFacets,
    toggleFilterAndSortModal = props.toggleFilterAndSortModal,
    filtersLabel = props.filtersLabel,
    filterAndSortLabel = props.filterAndSortLabel,
    translations = props.translations,
    selectedTab = props.selectedTab;
  var searchParams = (0, _navigation.useSearchParams)();
  var currentPage = searchParams && (searchParams === null || searchParams === void 0 ? void 0 : searchParams.get('currentPage')) || '1';
  var classes = useStyles();
  var setPerPage = 20;
  var _useState = (0, _react.useState)(+currentPage),
    paginationCount = _useState[0],
    setPaginationCount = _useState[1];
  var _useState2 = (0, _react.useState)({
      start: 0,
      end: setPerPage
    }),
    rangePerPage = _useState2[0],
    setRangePerPage = _useState2[1];
  var _useState3 = (0, _react.useState)(items.slice(rangePerPage.start, rangePerPage.end)),
    chunkData = _useState3[0],
    setChunkData = _useState3[1];
  var urlOverwrite = function urlOverwrite() {
    var initial = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var history, path;
    if (isBrowser) {
      var _history, _history$location, _history2, _history2$location;
      history = (0, _history3.createBrowserHistory)();
      path = ((_history = history) === null || _history === void 0 ? void 0 : (_history$location = _history.location) === null || _history$location === void 0 ? void 0 : _history$location.pathname) + ((_history2 = history) === null || _history2 === void 0 ? void 0 : (_history2$location = _history2.location) === null || _history2$location === void 0 ? void 0 : _history2$location.search);
    }
    var urlParts = path.split('&');
    var currentPageExists = false;
    urlParts === null || urlParts === void 0 ? void 0 : urlParts.forEach(function (part, index) {
      if (part.includes('currentPage')) {
        currentPageExists = true;
        urlParts[index] = "currentPage=".concat(initial);
      }
    });
    if (!currentPageExists) {
      if (path.includes('?')) {
        history.push("".concat(path, "&currentPage=").concat(initial));
      } else {
        history.push("".concat(path, "?currentPage=").concat(initial));
      }
    } else {
      history.push(urlParts.join('&'));
    }
  };
  var isFirstRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    // Skip the initial render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPaginationCount(1);
    urlOverwrite();
  }, [items === null || items === void 0 ? void 0 : items.length, selectedTab]);
  (0, _react.useEffect)(function () {
    if (Math.ceil(items.length / setPerPage) === paginationCount && items.length % setPerPage !== 0) {
      setRangePerPage(function (data) {
        return _objectSpread(_objectSpread({}, data), {}, {
          start: (paginationCount - 1) * setPerPage,
          end: items.length
        });
      });
    } else {
      setRangePerPage(function (data) {
        return _objectSpread(_objectSpread({}, data), {}, {
          start: rangePerPage.start === 0 && rangePerPage.end === setPerPage ? 0 : (paginationCount - 1) * setPerPage,
          end: paginationCount * setPerPage
        });
      });
    }
    setChunkData(items.slice(rangePerPage.start, rangePerPage.end));
    // scrollToTop when user click
    window.scrollTo(0, 0);
  }, [paginationCount, rangePerPage.start, rangePerPage.end, items]);
  (0, _react.useEffect)(function () {
    var timeoutId = setTimeout(function () {
      urlOverwrite(paginationCount);
    });
    return function () {
      return clearTimeout(timeoutId);
    }; // Cleanup the timeout on component unmount;
  }, [paginationCount]);
  var handlePageCountDropDown = function handlePageCountDropDown(param) {
    setPaginationCount(param);
    urlOverwrite(param.toString());
  };
  return __jsx("div", {
    role: "tabpanel",
    id: "".concat(id, "-panel"),
    "aria-labelledby": id
  }, __jsx(_FilterAndSortBar.default, {
    selectedFacets: selectedFacets,
    handleOnClick: toggleFilterAndSortModal,
    filtersLabel: filtersLabel,
    filterAndSortLabel: filterAndSortLabel
  }), chunkData && chunkData.length > 0 && renderContent ? __jsx("ul", {
    className: (0, _clsx.default)(wrapperClass, classes.list)
  }, chunkData.map(function (item, index) {
    return __jsx("li", {
      key: index
    }, renderContent(item));
  })) : emptyResultDefault, items.length > 0 ? __jsx(_PaginationWebinar.default, {
    numPages: Math.ceil(items.length / setPerPage),
    currentPage: paginationCount,
    totalItems: items.length,
    handleUpdatePage: handlePageCountDropDown,
    rangePerPage: rangePerPage,
    translations: translations
  }) : null);
};
var _default = ItemListPanel;
exports.default = _default;